import {
  Component,
  Input,
  ChangeDetectionStrategy,
  ElementRef,
  AfterViewInit,
  ViewChild,
} from '@angular/core';

/** Shown in place of course, quiz and report-card content when the learning track enforces course order. */
@Component({
  selector: 'ut-academy-course-locked',
  templateUrl: './academy-course-locked.component.html',
  styleUrls: ['./academy-course-locked.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AcademyCourseLockedComponent implements AfterViewInit {
  @Input() learningTrackName: string | undefined;

  @ViewChild('title') title!: ElementRef<HTMLElement>;

  // Move focus to the heading so assistive tech announces why there is no course content.
  ngAfterViewInit(): void {
    this.title?.nativeElement.focus({ preventScroll: true });
  }
}
